import React from 'react';

export default function GroupLogo({ band }) {
    return (
        <section className="relative bg-transparent w-full overflow-hidden -mx-[calc((100vw-100%)/2)] pt-[80px] md:pt-0">
            <img
                src={`https://api.palladium.rocks/images/${band.src}`}
                alt="logo Palladium"
                className="w-full h-auto block"
                loading="eager"
            />
        </section>
    );
}